import { dispatch } from "@rematch/core";

import {
  getOrderList,
  getItemsList,
  editItems,
  sendGoods,
  importOrder,
  reconfirmOk,
  reconfirmReject,
  batchSign,
  secondCheck,
  updateTags,
  exportOrder,
  allotOrder,
  saveAfterSale,
  getOrderListSum
} from "utils/interface";
import { CQ, CQNotWait } from "utils/commonQuest";

import { EHistoryType } from "utils/enum/orderListEnum";

const commonMethod = async function (payload: any, rootState: any, request) {
  // 允许接口完成调用后，执行组件中的方法
  const callback = payload.callback;
  const param = { ...payload };
  // 删除参数对象中的callback对象，以便不传多余的参数
  delete param.callback;
  // 等待异步调用的结果
  const { data, res } = await CQ(request(param), true);
  callback && callback(data, res);
};

// 订单信息相关
export const orderInfo = {
  state: {
    // 订单列表
    orderList: [],
    // 订单总数
    orderTotal: 0,
    // 订单列表查询模式
    orderRequestMode: EHistoryType.No,
    // 筛选项
    screeningItem: [],
    // 订单列表统计相关的信息
    statis: {
      // 子订单统计数据
      orderData: [],
      // tab栏上的统计
      tabData: [],
      // 已加载数据的标记
      isLoaded: false
    },
    // tab栏状态
    tabStatus: 1
  },
  reducers: {
    // 更新tab栏状态
    updateTabStatus(state, data: any) {
      state.tabStatus = data;
      return {
        ...state
      };
    },
    // 更新订单列表数据
    updateOrderList(state, data: any) {
      state.orderList = data.list;
      state.orderTotal = data.total;
      // 请求模式 1为 elasticsearch    2为传统sql
      state.orderRequestMode = data.requestMode == 1 ? 1 : 0;
      return {
        ...state
      };
    },
    // 更新筛选项列表
    updateScreeningItem(state, data: any) {
      state.screeningItem = data;
      return {
        ...state
      };
    },
    // 更新tab栏上的统计
    updateStatisTab(state, data: any) {
      state.statis.tabData = {
        ...state.statis.tabData,
        yiLou: data.yiLou,
        daiShenHe: data.daiShenHe,
        manYuan: data.manYuan,
        yiChang: data.yiChang,
        zhanWei: data.zhanWei
      };
      return {
        ...state
      };
    },
    // 更新子订单统计数据
    updateStatisOrder(state, data: any) {
      state.statis.isLoaded = true;
      state.statis.orderData = {
        ...state.statis.orderData,
        saleNums: data.saleNums,
        adultNum: data.adultNum,
        babyNum: data.babyNum,
        childrenNum: data.childrenNum
      };
      return {
        ...state
      };
    },
    // 更新统计状态
    updateStatisState(state, data: any) {
      state.statis.isLoaded = data;
      return {
        ...state
      };
    }
  },
  effects: {
    // 获取订单列表
    async getOrderList(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(getOrderList(param));
      callback();
      this.updateOrderList(data);
    },
    // 获取订单列表
    getOrderListAsync(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      CQNotWait(getOrderList(param), data => {
        callback();
        // 日期重叠tab特殊表格
        if (param.type == 13) {
          let newArr = { list: <any>[], total: <number>0, requestMode: <any>undefined }
          if(!data.list){
            data.list = []
            this.updateOrderList(data)
            return
          }
          data.list.map(item => {
            // 很多组件没有属性会报错 所以合并一下
            if (item.children[0]) {
              Object.assign(item, item.children[0])
              item.skuName = ''
            }
            item.id = Math.random()  // 随机id防止key重复引发的错误
            // 关于ant table的树状合并row的处理
            item.rowSpan = item.children.length + 1
            item.colSpan = 0
            item.goTime = ''
            item.submitDate = ''
            item.children.forEach(element => {
              element.rowSpan = 0
            });
            newArr.list.push(item)
          })
          newArr.total = Number(data.total)
          newArr.requestMode = 2
          console.log(newArr)
          this.updateOrderList(newArr)
        } else {
          this.updateOrderList(data);
        }
        dispatch["globalStatus"].updateTimestamp({
          orderListTimestamp: new Date().getTime()
        });
      });
    },
    // 获取筛选项列表
    async getItemsList(payload: any, rootState: any) {
      // 等待异步调用的结果
      const data = await CQ(getItemsList());
      this.updateScreeningItem(data);

      payload && payload.callback && payload.callback();
    },
    // 更新统计数据
    async getOrderListSum(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      this.updateStatisState(false);
      // 等待异步调用的结果
      getOrderListSum(payload);
      const data = await CQ(getOrderListSum(payload));
      this.updateStatis({ queryNum: payload.queryNum, data });
      callback && callback();
    },
    // 更新统计数据
    getOrderListSumAsync(payload: any, rootState: any) {
      console.log("Async2", "begin", new Date().getTime());
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      this.updateStatisState(false);
      // 等待异步调用的结果
      CQNotWait(getOrderListSum(param), data => {
        console.log("Async2", "end", new Date().getTime());
        setTimeout(() => {
          if (param.queryNum == 1) this.updateStatisOrder(data);
          else this.updateStatisTab(data);

          callback && callback();
        }, 1000);
      });
    },
    // 编辑筛选项
    async setScreeningItem(payload: any, rootState: any) {
      const callback = payload.callback;
      const param = { ...payload };
      delete param.callback;
      // 编辑筛选项
      const data = await CQ(editItems(payload));
      callback && callback(data);
    },
    // 批量发货
    async sendGoods(payload: any, rootState: any) {
      if (typeof payload.id === "string") {
      } else if (payload.ids instanceof Array) {
        payload.ids = payload.ids.join(",");
      }
      commonMethod(payload, rootState, sendGoods);
    },
    // 同步淘宝订单
    async importOrder(payload: any, rootState: any) {
      commonMethod(payload, rootState, importOrder);
    },
    // 二次确认同意
    async reconfirmOk(payload: any, rootState: any) {
      commonMethod(payload, rootState, reconfirmOk);
    },
    // 二次确认拒绝
    async reconfirmReject(payload: any, rootState: any) {
      commonMethod(payload, rootState, reconfirmReject);
    },
    // 批量签名
    async batchSign(payload: any, rootState: any) {
      // 数组参数改成字符加逗号分隔
      if (typeof payload.ids === "string") {
      } else if (payload.ids instanceof Array) {
        payload.ids = payload.ids.join(",");
      }
      commonMethod(payload, rootState, batchSign);
    },
    // 批量二次检查
    async secondCheck(payload: any, rootState: any) {
      // 数组参数改成字符加逗号分隔
      if (typeof payload.ids === "string") {
      } else if (payload.ids instanceof Array) {
        payload.ids = payload.ids.join(",");
      }
      commonMethod(payload, rootState, secondCheck);
    },
    // 批量售后 标异常
    async updateTags(payload: any, rootState: any) {
      commonMethod(payload, rootState, updateTags);
    },
    // 导出订单Excel
    async exportOrder(payload: any, rootState: any) {
      commonMethod(payload, rootState, exportOrder);
    },
    // 分配订单
    async allotOrder(payload: any, rootState: any) {
      commonMethod(payload, rootState, allotOrder);
    },
    // 创建售后单
    async saveAfterSale(payload: any, rootState: any) {
      commonMethod(payload, rootState, saveAfterSale);
    }
  }
};
